import api from './api';
import { FinancialStats, ChartData, PeriodFilter } from '../types';

export const financialService = {
  async getStats(period?: PeriodFilter): Promise<FinancialStats> {
    const response = await api.get<FinancialStats>('/financial/stats', {
      params: period
    });
    return response.data;
  },

  async getUsageByPartner(period?: PeriodFilter): Promise<ChartData[]> {
    const response = await api.get<ChartData[]>('/financial/usage-by-partner', {
      params: period
    });
    return response.data;
  },

  async getUsageByPeriod(period?: PeriodFilter): Promise<ChartData[]> {
    const response = await api.get<ChartData[]>('/financial/usage-by-period', {
      params: period
    });
    return response.data;
  },

  async getTopPartners(limit = 10): Promise<ChartData[]> {
    const response = await api.get<ChartData[]>('/financial/top-partners', {
      params: { limit }
    });
    return response.data;
  },

  async getTopAssociates(limit = 10): Promise<ChartData[]> {
    const response = await api.get<ChartData[]>('/financial/top-associates', {
      params: { limit }
    });
    return response.data;
  },

  async exportReport(period?: PeriodFilter, format: 'pdf' | 'excel' = 'pdf'): Promise<Blob> {
    const response = await api.get('/financial/export', {
      params: { ...period, format },
      responseType: 'blob'
    });
    return response.data;
  }
};
